export default __webpack_public_path__ + "static/media/noHomesIcon.724a3e11.svg";